export enum PropertyCountry {
  ITALY = 'IT',
  UNITED_STATES = 'US',
  UNITED_ARAB_EMIRATES = 'AE',
  SPAIN = 'ES',
}
